import React, { useContext, useEffect, useState } from "react";

import { INTEGRATION_PROVIDERS } from "@src/constants/integration-provider.model";
import { services } from "@src/dependencies";
import { useApiRequest } from "@utils/http-client";
import { SessionContext } from "./session.context";

export const IntegrationsContext = React.createContext({});

export default ({ children }) => {
  const [integrations, setIntegrations] = useState();
  const [integrationsCount, setIntegrationsCount] = useState();
  const { integrationService } = services;
  const { currentUser } = useContext(SessionContext);

  const { loading, sendRequest } = useApiRequest(async () => {
    try {
      const providers = await integrationService.getProviders({
        includeDisabled: true,
      });
      const providerIcons = await Promise.allSettled(
        providers.map((provider) =>
          integrationService.getProviderIconRect(provider.id),
        ),
      ).then((results) =>
        results.reduce((acc, result, index) => {
          if (result.status === "fulfilled") {
            acc[providers[index].name] = result.value;
          }
          return acc;
        }, {}),
      );

      const integrations = await integrationService.getAllConnectionHistory(
        0,
        "all",
      );
      integrations.forEach((integration) => {
        integration.status = integration.status.toLowerCase();
        integration.parentOrganizationName =
          integration.parentOrganization?.name;

        integration.organizationName = integration.organization.name;
        integration.ssoEnabled = integration.organization.sso_enabled;

        if (integration.idp) {
          integration.idpName = integration.idp.name;
          integration.idpIcon =
            providerIcons[INTEGRATION_PROVIDERS[integration.idp.typeId]];
        }

        const [createdRecords, updatedRecords, erroredRecords] =
          integration.results.reduce(
            (acc, r) => {
              acc[0] += r.create;
              acc[1] += r.update;
              acc[2] += r.error;
              return acc;
            },
            [0, 0, 0],
          );
        integration.createdRecords = createdRecords;
        integration.updatedRecords = updatedRecords;
        integration.erroredRecords = erroredRecords;
        integration.totalRecords =
          createdRecords + updatedRecords + erroredRecords;
      });

      setIntegrations(
        integrations.sort((a, b) =>
          a.organizationName.localeCompare(b.organizationName),
        ),
      );
    } catch (error) {
      console.error(error);
      setIntegrations();
    }
  }, false);

  const contextValue = {
    integrations,
    integrationsCount,
    loadingIntegrations: loading,
    updateIntegrations: sendRequest,
  };

  useEffect(() => {
    if (currentUser) {
      contextValue.updateIntegrations();
    } else {
      setIntegrations();
    }
  }, [currentUser]);

  useEffect(() => {
    setIntegrationsCount(integrations?.length);
  }, [integrations]);

  return (
    <IntegrationsContext.Provider value={contextValue}>
      {children}
    </IntegrationsContext.Provider>
  );
};
